var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "custom-black-list-extra-options" },
      [
        _c(
          "VButton",
          {
            ref: "button",
            on: {
              mouseover: _vm.setBlackListProps,
              click: _vm.toggleBlackList,
            },
          },
          [
            _vm._v("\n      黑名单\n      "),
            _c("VIcon", { attrs: { icon: "right-arrow", size: 16 } }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }